import {required} from "vuelidate/lib/validators";   
const StrRisklerGirislerCevap = {
    data() {
      return {   
        StrRisklerGirislerCevapData:{ 
          GirisId:null,
          BirimId:null,
          Cevaptipi:null,
          Cevap:null,
          Aciklama:null,
          BaslamaTarihi: null,
          BitisTarihi: null,
          Tamamlanma: 0,
          Durum: 0,
          Onay: 0,
          Deleted: false 
        },
        FormDataType:  { 
          BirimId:{FieldName:"BirimId",Field:"combobox",FieldTitle:this.$t('StrRisklerGirislerCevap.AddEdit.BirimId'),ComboDataArray:[]},  
          Cevaptipi:{FieldName:"Cevaptipi",Field:"combobox",FieldTitle:this.$t('StrRisklerGirislerCevap.AddEdit.Cevaptipi'),ComboDataArray:[]},  
          Cevap:{FieldName:"Cevap",Field:"textarea",FieldTitle:this.$t('StrRisklerGirislerCevap.AddEdit.Cevap')},  
          Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle: this.$t('StrRisklerGirislerCevap.AddEdit.Aciklama'),FieldType:"text"},
          BaslamaTarihi:{FieldName:"BaslamaTarihi",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.BaslamaTarihi'),FieldType:"date"},
          BitisTarihi:{FieldName:"BitisTarihi",Field:"input",FieldTitle: this.$t('StrPerfDonem.AddEdit.BitisTarihi'),FieldType:"date"},
          Tamamlanma:{FieldName:"Tamamlanma",Field:"input",FieldTitle:"Tamamlanma",FieldType:"number"},

        },
        CevapTipleri:[
          {"id":"0","value":"Riske Verilecek Cevap"},
          {"id":"1","value":"Yeni Kontrol"},
          {"id":"2","value":"Ek Kontrol"},
          {"id":"3","value":"Kaldırılan Kontrol"},
          {"id":"4","value":"Yönlendirici Kontroller"},
          {"id":"5","value":"Önleyici Kontroller"},
          {"id":"6","value":"Tespit Edici Kontrol"},
          {"id":"7","value":"Düzeltici Kontrol"},
        
        ]
      }
    },
    validations:{  
      FormData: { 
        BirimId: { required }, 
        Cevaptipi: {required},
        Cevap: { required } ,
        Aciklama:{} ,
        BaslamaTarihi: {},
        BitisTarihi: {},
        Tamamlanma:{},
      }
 
  }, 
  created(){ 
    let Page= {
      PageNumber: "1",
      PageSize: "9999"
    } 
    this.ActionsGet({"Service":"OBirim","Page":Page}).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.FormDataType.BirimId.ComboDataArray.push ({Id:res.Data[i].Id,Value:res.Data[i].BirimAdi})
        }    
    }); 

    this.FormDataType.Cevaptipi.ComboDataArray=[];
    for (var i=0 ; i<this.CevapTipleri.length; i++){
      this.FormDataType.Cevaptipi.ComboDataArray.push ({Id:this.CevapTipleri[i].id,Value:this.CevapTipleri[i].value})
    }
    
  }
}
export default StrRisklerGirislerCevap